var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("studip-dialog", {
        attrs: {
          title: _vm.$gettext("Feedback"),
          closeText: _vm.$gettext("Schließen"),
          closeClass: "cancel",
          height: _vm.height,
          width: _vm.width,
        },
        on: {
          close: function close($event) {
            return _vm.$emit("close")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "dialogContent",
            fn: function fn() {
              var _vm$feedbackElement, _vm$feedbackElement$a
              return [
                !_vm.loadingFeedbackElement
                  ? _c(
                      "div",
                      {
                        staticClass: "feedback-dialog",
                      },
                      [
                        _c("feedback-five-stars-histogram", {
                          attrs: {
                            entries: _vm.entries,
                            vertical: true,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "feedback-dialog-content",
                          },
                          [
                            !_vm.editElement
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "feedback-dialog-content-header",
                                    },
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              (_vm$feedbackElement =
                                                _vm.feedbackElement) === null ||
                                                _vm$feedbackElement === void 0
                                                ? void 0
                                                : (_vm$feedbackElement$a =
                                                    _vm$feedbackElement.attributes) ===
                                                    null ||
                                                  _vm$feedbackElement$a ===
                                                    void 0
                                                ? void 0
                                                : _vm$feedbackElement$a.question
                                            ) +
                                            "\n                            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "as-link",
                                          on: {
                                            click: function click($event) {
                                              _vm.editElement = true
                                            },
                                          },
                                        },
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "edit",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "as-link",
                                          on: {
                                            click: function click($event) {
                                              _vm.showDeleteFeedbackDialog = true
                                            },
                                          },
                                        },
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "trash",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasDescription
                                    ? _c("div", [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(_vm.$gettext("Beschreibung"))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                          domProps: {
                                            innerHTML: _vm._s(_vm.description),
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              : _c("feedback-element-update", {
                                  attrs: {
                                    feedbackElementId: _vm.feedbackElementId,
                                  },
                                  on: {
                                    cancel: function cancel($event) {
                                      _vm.editElement = false
                                    },
                                    submit: _vm.updateFeedbackElement,
                                  },
                                }),
                            _vm._v(" "),
                            !_vm.currentUserIsAuthor
                              ? [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$gettext("Meine Bewertung"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.hasCurrentUserEntry || _vm.editEntry
                                    ? _c("feedback-entry-create", {
                                        attrs: {
                                          feedbackElement: _vm.feedbackElement,
                                          entry: _vm.currentUserEntry[0],
                                          currentUser: _vm.currentUser,
                                        },
                                        on: {
                                          submit: function submit($event) {
                                            _vm.editEntry = false
                                          },
                                          cancel: function cancel($event) {
                                            _vm.editEntry = false
                                          },
                                        },
                                      })
                                    : _c("feedback-entry-box", {
                                        staticClass: "current-user-entry",
                                        attrs: {
                                          entry: _vm.currentUserEntry[0],
                                          canEdit: true,
                                          canDelete: true,
                                        },
                                        on: {
                                          edit: function edit($event) {
                                            _vm.editEntry = true
                                          },
                                          delete: _vm.showDeleteEntry,
                                        },
                                      }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(_vm._s(_vm.$gettext("Bewertungen"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(_vm.otherUserEntries, function (entry) {
                                return _c(
                                  "li",
                                  {
                                    key: entry.id,
                                  },
                                  [
                                    _c("feedback-entry-box", {
                                      attrs: {
                                        entry: entry,
                                        canDelete: _vm.canEditFeedbackElement,
                                      },
                                      on: {
                                        delete: _vm.showDeleteEntry,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.entries.length === 0
                              ? _c("p", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Es wurden noch keine Bewertungen abgegeben."
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.otherUserEntries.length === 0 &&
                            _vm.entries.length > 0
                              ? _c("p", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Es wurden noch keine weiteren Bewertungen abgegeben."
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.showDeleteEntryDialog
                          ? _c("studip-dialog", {
                              attrs: {
                                title: _vm.$gettext("Feedback-Eintrag löschen"),
                                question: _vm.$gettext(
                                  "Möchten Sie den Eintrag wirklich unwiderruflich löschen?"
                                ),
                                height: "200",
                              },
                              on: {
                                confirm: _vm.executeDeleteFeedbackEntry,
                                close: _vm.closeDeleteEntry,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("studip-progress-indicator", {
                      attrs: {
                        description: _vm.$gettext("Lade Bewertungen…"),
                      },
                    }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showDeleteFeedbackDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Feedback-Element löschen"),
              question: _vm.$gettext(
                "Möchten Sie das Feedback-Element wirklich unwiderruflich löschen? Alle Bewertungen werden ebenfalls gelöscht!"
              ),
              height: "200",
            },
            on: {
              confirm: _vm.executeDeleteFeedback,
              close: function close($event) {
                _vm.showDeleteFeedbackDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }